import React, { useEffect, useState } from "react";
import styles from "./Cells.module.scss";

import correctImage from "./images/Correct.svg";
import incorrectImage from "./images/Incorrect.svg";

export interface OptionsInfo {
  id: string;
  value: string;
  text: string;
  selected: boolean;
}

interface CellProps {
  cellId: string;
  imageURL: string;
  altText: string;
  options: OptionsInfo[];
  onOptionSelected: (cellId: string, optionId: string) => void;
  correct: boolean;
  answered: boolean;
  correctFeedback: string;
  incorrectFeedback: string;
  selectedOption: string;
}

export function Cell(props: CellProps) {
  const [selectedOption, setSelectedOption] = useState<string>(
    props.selectedOption || ""
  );
  const [image, setImage] = useState<string>("");

  const onOptionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = event.target.value;
    setSelectedOption(selectedId);
    props.onOptionSelected(props.cellId, selectedId);
  };

  useEffect(() => {
    const newImage = props.correct
      ? correctImage
      : props.answered
        ? incorrectImage
        : "";
    setImage(newImage);
  }, [props.correct, props.answered]);

  console.log(selectedOption);

  return (
    <div className={styles.cellContainer}>
      <img
        className={styles.cellImage}
        src={props.imageURL}
        alt={props.altText}
      />
      <div className={styles.selectWrapper}>
        <select
          className={`${styles.cellSelect} ${props.correct ? styles.cellCorrect : props.answered ? styles.cellIncorrect : ""} ${selectedOption == "" ? styles.placeholder : ""}`}
          value={selectedOption}
          onChange={onOptionChange}
        >
          <option value="" disabled>
            - Select -
          </option>
          {props.options.map((option) => (
            <option
              className={styles.cellOption}
              key={option.id}
              value={option.id}
              disabled={props.correct}
            >
              {option.text}
            </option>
          ))}
        </select>
        {image && (
          <img src={image} alt="status" className={styles.statusIcon} />
        )}
      </div>
      <div
        style={{ display: props.answered ? "block" : "none" }}
        className={`${props.correct ? styles.feedbackCorrect : props.answered ? styles.feecbackIncorrect : ""}`}
      >
        {props.correct ? props.correctFeedback : props.incorrectFeedback}
      </div>
    </div>
  );
}
